// /client/src/pages/admin/SkillsPage.js
import React, { useState, useEffect } from 'react';
import {
  Box, Button, Typography, Paper, Chip, Stack, IconButton, CircularProgress
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import SkillForm from '../../components/SkillForm';

const SkillsPage = () => {
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [skillToEdit, setSkillToEdit] = useState(null);
  const { token } = useAuth();

  const fetchSkills = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/skills`);
      setSkills(res.data);
    } catch (error) {
      console.error('Failed to fetch skills:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchSkills(); }, []);

  const handleOpenForm = (skill = null) => {
    setSkillToEdit(skill);
    setIsFormOpen(true);
  };

  const handleCloseForm = () => {
    setSkillToEdit(null);
    setIsFormOpen(false);
  };

  const handleSave = async (formData, skillId) => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      if (skillId) {
        await axios.put(`http://localhost:5001/api/skills/${skillId}`, formData, config);
      } else {
        await axios.post('http://localhost:5001/api/skills', formData, config);
      }
      fetchSkills();
      handleCloseForm();
    } catch (error) {
      console.error('Failed to save skill:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this skill?')) {
      try {
        await axios.delete(`http://localhost:5001/api/skills/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        fetchSkills();
      } catch (error) {
        console.error('Failed to delete skill:', error);
      }
    }
  };

  if (loading) return <CircularProgress />;

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h4">Manage Skills</Typography>
        <Button variant="contained" onClick={() => handleOpenForm()}>Add Skill</Button>
      </Box>
      <Paper sx={{ p: 2 }}>
        <Stack direction="row" flexWrap="wrap" spacing={1}>
          {skills.map((skill) => (
            <Chip
              key={skill._id}
              label={skill.name}
              onDelete={() => handleDelete(skill._id)}
              deleteIcon={<DeleteIcon />}
              onClick={() => handleOpenForm(skill)}
              sx={{ '& .MuiChip-deleteIcon': { color: 'rgba(255, 255, 255, 0.7)' }, '&:hover': {
                '& .MuiChip-deleteIcon': { color: 'white' }
              }}}
            />
          ))}
        </Stack>
      </Paper>
      <SkillForm open={isFormOpen} onClose={handleCloseForm} onSave={handleSave} skill={skillToEdit} />
    </Box>
  );
};

export default SkillsPage;